import { merge } from 'ramda'
import { createReducer } from '../lib/reducer'
import ActionTypes from '../actions/types'

const initialState = {
  showWelcomeBackBanner: false,
  // rendered height in px, 0 while hidden; ServiceMessages sits below it
  welcomeBackBannerHeight: 0
}

const ui = createReducer(initialState, {
  [ActionTypes.SET_SHOW_WELCOME_BACK_BANNER]: (state, { payload }) => {
    return merge(state, { showWelcomeBackBanner: payload })
  },
  [ActionTypes.SET_WELCOME_BACK_BANNER_HEIGHT]: (state, { payload }) => {
    return merge(state, { welcomeBackBannerHeight: payload })
  }
})

export default ui
